<template lang="pug">
  main
    NavBarAccesos
    Loader(v-show="isLoading")
    ModalInfo(v-show="modalStatus" :title="titleModal" :content="contentModal" @padre:close="cerrarModal")
    section.hero(v-show="!isLoading")
      .container
        h3.title Editar Acceso
        .columns
          .column.is-half
            .field
              input#isS.is-checkradio.is-primary(type='radio', value='false' v-model='isFull' checked='checked')
              label.is-size-6(for='isS') Sencillo
              input#isF.is-checkradio.is-primary(type='radio', value='true' v-model='isFull')
              label.is-size-6(for='isF') Full
        .columns
          .column.is-half
            .field
              label.label Autotanque {{ letraFullA }}
              TypeaheadPG(:options="autotanquesBD" :optionSelect="itemDataAuto" v-model="itemSelAuto" :isDisabled="isformAccesoDisabled")
            .field(v-show="isVisibleFull")
              label.label Autotanque {{ letraFullB }}
              TypeaheadPG(:options="autotanquesBD_Full" :optionSelect="itemDataAutoFull" v-model="itemSelAutoFull" :isDisabled="isformAccesoDisabled")
          .column.is-half(v-if="itemsAutoSelect.length > 0")
            ListCardsAutotanques(:listAutotanques="itemsAutoSelect")
        .columns(v-show="!verAgregarOper")
          .column.is-half
            .field
              label.label Operador
              TypeaheadPorteador(:options="operadores" :optionSelect="itemDataOper" v-model="itemSelOper" :isDisabled="isTH_disabled || isformAccesoDisabled")
          .column.is-half
            FormOperador(:operador="itemSelOper" v-show="Object.keys(itemSelOper).length > 0" @updateOperador="checkFormOperadores")
        .columns(v-show="verAgregarOper")
          .column.is-half
            .field
              label.label Escriba el Nombre del Operador No Registrado
                .control
                  input.input.is-primary(
                    type='text', 
                    v-model="operadorNuevo"
                  )
            a.button.is-primary(@click="guardarOperador" v-show="verAgregarOper") Guardar Operador
        .columns
          .column.is-half
            .field
              label.label Carga para:
              .control
                .select.is-primary
                  select(v-model="gruposSelect" :disabled="isformAccesoDisabled")
                    option(v-for="g in grupos" :key="g.id" :value="g.id") {{ g. nombre}}
            span(v-html="resultNom")
        .columns
          .column.is-half
            button.button.is-warning(@click="editLlegada" v-show="isVisibleFinish && isformAccesoEditing") Editar Llegada
            | &nbsp
            button.button.is-primary(@click="updateLlegada" v-show="isVisibleFinish && isformAccesoUpdating") Actualizar Llegada
            | &nbsp
            button.button.is-dark(@click="cancelEditLlegada" v-show="isVisibleFinish && isformAccesoUpdating") Cancelar Llegada
        .columns.column-blanco
</template>

<script>
  import autotanquesServicesIRGE from '@/services/irge/autotanquesIRGE.js'
  import turnosServicesIRGE from '@/services/irge/turnosIRGE.js'
  import sca_irgeServices from '@/services/sca/irge.js'
  import ModalInfo from '@/components/sca_Componentes/acceso/shared/ModalInfo.vue'
  import NavBarAccesos from '@/components/sca_Componentes/acceso/layout/NavBarAccesos.vue'
  import Loader from '@/components/shared/Loader.vue'
  import moment from 'moment'
  import ListCardsAutotanques from '@/components/sca_Componentes/acceso/ListCardsAutotanques.vue'
  import FormOperador from '@/components/sca_Componentes/acceso/FormOperador.vue'
  import TypeaheadPG from '@/components/sca_Componentes/acceso/shared/TypeaheadPG.vue'
  import TypeaheadPorteador from '@/components/sca_Componentes/acceso/shared/TypeaheadPorteador.vue'

  import { mapState } from 'vuex'

  import vueFilePond from 'vue-filepond'
  import '../../../../node_modules/filepond/dist/filepond.min.css'

  import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.min.js'
  import FilePondPluginImagePreview from 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.js'

  // Import styles
  import 'filepond/dist/filepond.min.css'
  import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'

  // Create FilePond component
  const FilePond = vueFilePond( FilePondPluginFileValidateType, FilePondPluginImagePreview )

  export default {
    name: 'EditarAcceso',
    components: { Loader, TypeaheadPG, TypeaheadPorteador, NavBarAccesos, FilePond, ModalInfo, ListCardsAutotanques, FormOperador },
    data() {
      return {
        isLoading: true,
        autotanquesBD: [],
        autotanquesBD_Full: [],
        operadores: [],
        itemDataOper: {},
        itemDataAuto: {},
        itemDataAutoFull: {},
        itemSelOper: {},
        itemSelAuto: {},
        itemSelDestino: {},
        itemDataDestino: {},
        itemSelAutoFull: {},
        isVisibleFinish: false,
        isTH_disabled: false,
        isFull: 'false',
        isVisibleFull: false,
        letraFullA: '',
        letraFullB: '',
        itemsAutoSelect: [],
        modalStatus: false,
        titleModal: '',
        contentModal: '',
        destinos:[],
        destinoSelected: {},
        unidadNegocio: {},
        resultNom: '<span></span>',
        puedeCargar: false,
        telefono: '',
        grupos: [
          { id: 'gN', nombre: 'NIETO'},
          { id: 'gSI', nombre: 'SONIGAS-I'},
          { id: 'gSM', nombre: 'SONIGAS-MX'},
          { id: 'gG', nombre: 'GLOBAL'},
          { id: 'gMN', nombre: 'METRO NIETO'},
          { id: 'gMab', nombre: 'MABARAK'},
          { id: 'gU', nombre: 'URIBE'},
          { id: 'gMet', nombre: 'METROPOLITANO'},
          { id: 'gUP', nombre: 'URIBE-PROPANGOL'}
        ],
        gruposSelect: '',
        fechaJornada: '',
        verAgregarOper: false,
        operadorNuevo: '',
        verCards_autotanques: false,
        updateOperador: false,
        acceso: {},
        tanqueA: {},
        tanqueB: {},
        isformAccesoDisabled: true,
        isformAccesoEditing: true,
        isformAccesoUpdating: false,
        count_Actualizados: 0,
        count_turnosActualizados: 0,
        tanquesOld: []
      }
    },
    watch: {
      itemSelAuto () {
        console.log('wathc: itemAuto:')
        console.log(this.itemSelAuto)
        this.itemsAutoSelect = []
        autotanquesServicesIRGE.searchAccesos_PG_Pendientes(this.itemSelAuto.pg)
          .then(res => {
            console.log(res)
            if (res.length > 0) {

              if (res[0].pg !== this.tanqueA.pg) {
                this.titleModal = 'Autotanque no válido.'
                this.contentModal = `El Autotanque ${this.itemSelAuto.pg} aun no ha registrado su salida.`
                this.modalStatus = true
              }
              // this.itemSelAuto = {}
              // this.itemDataAuto = {}
              
            } else {
              console.log('Este pg no tiene Registros')
              if (Object.keys(this.itemSelAuto).length > 0) {
                this.itemsAutoSelect.push(this.itemSelAuto)
              }
              if (Object.keys(this.itemSelAutoFull).length > 0) {
                this.itemsAutoSelect.push(this.itemSelAutoFull)
              }
            }
          })
        this.autotanquesBD_Full = this.autotanquesBD.filter( auto => auto.pg !== this.itemSelAuto.pg)
      },

      itemSelAutoFull () {
        console.log('wathc: itemAutoFull:')
        console.log(this.itemSelAutoFull)
        this.itemsAutoSelect = []
        autotanquesServicesIRGE.searchAccesos_PG_Pendientes(this.itemSelAutoFull.pg)
          .then(res => {
            console.log(res)
            if (res.length > 0) {

              if (res[0].pg !== this.tanqueB.pg) {
                this.titleModal = 'Autotanque no válido.'
                this.contentModal = `El Autotanque ${this.itemSelAutoFull.pg} aun no ha registrado su salida.`
                this.modalStatus = true
              }
              // this.itemSelAutoFull = {}
              // this.itemDataAutoFull = {}
              
            } else {
              console.log('Este pg no tiene Registros')
              if (Object.keys(this.itemSelAuto).length > 0) {
                this.itemsAutoSelect.push(this.itemSelAuto)
              }

              if (Object.keys(this.itemSelAutoFull).length > 0) {
                this.itemsAutoSelect.push(this.itemSelAutoFull)
              }
            }
          })
      },

      itemSelOper () {
        console.log('wathc: itemSelOper')
        this.isTH_disabled = false
        console.log(`isTH_disabled: ${this.isTH_disabled}`)
        if ( Object.keys(this.itemSelAuto).length !== 0 ) {
          if ( Object.keys(this.itemSelOper).length !== 0 ) {
            this.isVisibleFinish = true
          } else {
            this.isVisibleFinish = false
          }
        } else {
          this.isVisibleFinish = false            
        }

        if (this.itemSelOper.id === '20191212') {
          this.verAgregarOper = true
        } else {
          this.verAgregarOper = false
        }
      },
      gruposSelect () {
        console.log(`wathc: grupoSelect:}`)
        console.log(this.gruposSelect)
        this.comprobarNominacion()
      },

      isFull () {
        console.log(`wathc: isFull: ${this.isFull}`)
        if (this.isFull === 'true'){
          this.isVisibleFull = true
          this.letraFullA = 'A'
          this.letraFullB = 'B'
        } else {
          this.isVisibleFull = false
          this.letraFullA = ''
          this.letraFullB = ''
          this.itemsAutoSelect.splice(1,1)
          this.itemSelAutoFull = {}
          this.itemDataAutoFull = {}
        }
      }
    },
    methods: {
      iniciarComponente() {
        const id = this.$route.params.id
        console.log(id)
        autotanquesServicesIRGE.getAcceso(id)
          .then( res => {
            console.log(res)
            this.acceso = res[0]
            autotanquesServicesIRGE.getAutos_claveTurno(this.acceso.claveTurno)
              .then( rTanques => {
                console.log(rTanques)
                console.log(`rTanques: ${rTanques.length}`)
                
                switch (rTanques.length) {
                  case 0:
                    console.log('No tiene autotanques ingresados')
                    break
                  case 1:
                    this.tanqueA = rTanques[0]
                    this.isFull = 'false'
                    this.isVisibleFull = false
                    this.tanquesOld.push(this.tanqueA)
                    console.log(`rTanques.lenght :1 | isFull: ${this.isFull} | isVisibleFull: ${this.isVisibleFull}`)
                    break
                  case 2:
                    this.isFull = 'true'
                    this.isVisibleFull = true
                    this.tanqueA = rTanques[0]
                    this.tanqueB = rTanques[1]
                    this.tanquesOld.push(this.tanqueA)
                    this.tanquesOld.push(this.tanqueB)
                    console.log(`rTanques.lenght :2 | isFull: ${this.isFull} | isVisibleFull: ${this.isVisibleFull}`)
                    break
                
                  default:
                    break
                }

                console.log(this.tanqueA)
                console.log(this.tanqueB)
                this.obtenerAutos()

              })
              .catch( er => console.log(er))
          })
          .catch( e => console.log(e))
      },
      obtenerAutos () {
        sca_irgeServices.getAutotanques()
          .then(res => {
            console.log(res)
            if (this.isFull === 'true') {
              this.autotanquesBD = res.filter( auto => auto.pg !== this.tanqueA.pg && auto.pg !== this.tanqueB.pg)
              this.itemSelAuto = res.find( auto => auto.pg === this.tanqueA.pg)
              this.itemDataAuto = this.itemSelAuto
              this.itemSelAutoFull = res.find( auto => auto.pg === this.tanqueB.pg)
              this.itemDataAutoFull = this.itemSelAutoFull
            } else {
              this.autotanquesBD = res.filter( auto => auto.pg !== this.tanqueA.pg)
              this.itemSelAuto = res.find( auto => auto.pg === this.tanqueA.pg)
              this.itemDataAuto = this.itemSelAuto
            }

            this.obtenerOperadores()
          })
      },
      obtenerOperadores () {
        sca_irgeServices.getOperadores()
          .then(resOper => {
            console.log(resOper)
            this.operadores = resOper
            //this.obtenerDestinos()
            setTimeout(() => {
              if (this.updateOperador) {
                this.cambiarOperadorForm()
              }
              this.isLoading = false
              this.itemDataOper = this.operadores.find( oper => oper.id === this.acceso.idOperador)
              this.itemSelOper = this.itemDataOper
              let this_gruposSelect = this.grupos.find( gr => gr.id === this.acceso.subgrupo)
              this.gruposSelect = this_gruposSelect.id
              this.fechaJornada = this.acceso.fechaLlegada.substr(0, 10)
              setTimeout(() => {
                this.obtenerCardsTanques()
              }, 350)
            }, 350)
          })
      },
      obtenerCardsTanques() {
        // console.log(Object.keys(this.itemSelAuto).length > 0)
        // console.log(Object.keys(this.itemSelAutoFull).length > 0)
        if (Object.keys(this.itemSelAuto).length > 0) {
          console.log('this.itemsAutoSelect.push(this.itemSelAuto)')
          this.itemsAutoSelect.push(this.itemSelAuto)
        }
        if (Object.keys(this.itemSelAutoFull).length > 0) {
          console.log('this.itemsAutoSelect.push(this.itemSelAutoFull)')
          this.itemsAutoSelect.push(this.itemSelAutoFull)
        }
        console.log(this.itemsAutoSelect)
      },

      editLlegada () {
        this.isformAccesoDisabled = false
        this.isformAccesoEditing = false
        this.isformAccesoUpdating = true
      },

      updateLlegada () {
        //Ver si puede cargar
        if (this.puedeCargar) {
          this.isLoading = true
          // Ver si cambia de grupo ...
          let claveTurnoNew = ''
            if (this.gruposSelect === this.acceso.subgrupo) {
              console.log('Mismo Grupo --> Mantener la claveTurno')
              claveTurnoNew = this.acceso.claveTurno

            } else {
              console.log('Otro Grupo --> Nueva claveTurno')
              let ahoraturno = moment().format('YYYYMMDDHHmmss')
              claveTurnoNew = `${this.gruposSelect}${ahoraturno}`

            }
            console.log(claveTurnoNew)
            autotanquesServicesIRGE.getAutos_claveTurno(this.acceso.claveTurno)
              .then( rA_CT => {
                console.log('Obteniendo Tanques por turno de accesos')
                console.log(rA_CT)
                var index = 0
                  rA_CT.forEach(accesosCT => {
                    console.log(index)
                    if (typeof this.itemsAutoSelect[index] !== 'undefined') {
                      console.log('Itemsel auto: No es undefined')
                      var pgIndex = this.itemsAutoSelect[index].pg
                      var pgOld = this.tanquesOld[index].pg
                      var capacidad = parseInt(this.itemsAutoSelect[index].capacidad) /1000
                        autotanquesServicesIRGE.updateAcceso_Inicio(accesosCT.id, pgIndex, claveTurnoNew, this.itemSelOper.id, this.itemSelOper.nombre, this.itemSelOper.telefono, this.itemSelOper.foto, this.gruposSelect)
                          .then( res => {
                            console.log('actualizando datos de acceso')
                            console.log(res)
                            if (res.success) {
                              autotanquesServicesIRGE.updatePuntosPG_Inicio(accesosCT.id, pgIndex)
                                .then( resPG => {
                                  console.log('actualizando puntos de pg')
                                  console.log(resPG)
                                  if (resPG.success) {
                                    console.log(resPG.respuesta)
                                    let cap = capacidad * 1000
                                    let cap82 = (cap * 82) / 90
                                    let barriles = cap82 / 158.9873
                                    let tons = barriles / 11.83
                                    turnosServicesIRGE.updateTurno_PG(this.acceso.claveTurno, claveTurnoNew, pgOld, pgIndex, this.gruposSelect, capacidad, tons)
                                      .then( resUT => {
                                        console.log(resUT)
                                        if (resUT.success) {
                                          console.log(`Actualizado de tanque ${pgOld} a ${pgIndex}`)
                                        } else {
                                          let toast = this.$toasted.show(`error: ${resUT.respuesta}.`, { 
                                            theme: "toasted-primary", 
                                            position: "bottom-right", 
                                            duration : 3000,
                                            iconPack: 'fontawesome',
                                            icon: 'exclamation-triangle',
                                            action : {
                                              text : 'Ok',
                                              onClick : (e, toastObject) => {
                                                toastObject.goAway(0)
                                              }
                                            },
                                          })
                                        }
                                        this.count_turnosActualizados++
                                        if (this.count_turnosActualizados == res.length) {
                                          let toast = this.$toasted.show(`Los Datos del Acceso han sido actualizados.`, { 
                                            theme: "toasted-primary", 
                                            position: "bottom-right", 
                                            duration : 3000,
                                            iconPack: 'fontawesome',
                                            icon: 'check',
                                            action : {
                                              text : 'Ok',
                                              onClick : (e, toastObject) => {
                                                this.$router.push('/IRGE/Accesos')
                                                toastObject.goAway(0)
                                              }
                                            },
                                          })
                                          this.count_turnosActualizados = 0
                                          this.isLoading = false
                                          // setTimeout(() => {
                                          //   this.isLoading = false
                                          //   this.$router.push('/TPA/SCA/Accesos')
                                          // }, 250)
                                        }
                                      })
                                      .catch( error => console.log(error))

                                  } else {
                                    console.log(`Error en Puntos PG: ${resPG.respuesta}`)
                                  }
                                })
                                .catch( e => console.log(e))
                            } else {
                              console.log(res.respuesta)
                            }
                            this.count_Actualizados++
                            if (this.count_Actualizados == rA_CT.length) {
                              console.log(`Count: ${this.count_Actualizados} =  rA_CT.length ${rA_CT.length}`)
                              console.log('Completos Update Accesos')
                              setTimeout(() => {
                                this.checkFaltantes(claveTurnoNew)
                              }, 350)
                            } else {
                              console.log(`Count: ${this.count_Actualizados} !=  rA_CT.length ${rA_CT.length}`)
                              console.log('Incompletos Update Accesos')
                            }
                          })
                          .catch( e => console.log(e))
                          index++
                    } else {
                      console.log('Itemsel auto: Undefined')
                      // eliminar el que no existe
                      autotanquesServicesIRGE.deleteAcceso_Id(accesosCT.id)
                        .then( rDA => {
                          console.log(rDA)
                          if (rDA.success) {
                            console.log('Eliminado Acceso')
                            autotanquesServicesIRGE.deletePg_Puntos(accesosCT.id)
                            .then( rDPP => {
                              console.log(rDPP)
                              if (rDPP.success) {
                                console.log('Eliminado Acceso || Puntos')
                                turnosServicesIRGE.eliminar_PG_ClaveTurno(accesosCT.pg, this.acceso.claveTurno)
                                  .then( rDT => {
                                    console.log(rDT)
                                    if (rDT.success) {
                                      console.log('Eliminado Acceso || Puntos || Turno')
                                      this.$router.push('/IRGE/Accesos')
                                    } else {
                                      console.log(rDT.respuesta)
                                    }
                                  })
                                  .catch(eDT => console.log(eDT))
                              } else {
                                console.log(rDPP.success)
                              }
                            })
                            .catch(eDP => console.log(eDP))
                          } else {
                            console.log(rDA.respuesta)
                          }
                          index++
                        })
                        .catch(e => {
                          index++
                          console.log(e)
                        })
                    }
                  })
                  
                   
              })
              .catch( e => {
                console.log(e)
                console.log(index)
                console.log(`count: ${this.count_Actualizados} - items: ${this.itemsAutoSelect.length}`)
              })

              console.log(`count: ${this.count_Actualizados} - items: ${this.itemsAutoSelect.length}`)
              if (this.count_Actualizados < this.itemsAutoSelect.length) {
                console.log('Agregar item full faltante')
              }  else if (this.count_Actualizados == this.itemsAutoSelect.length){
                console.log('Igual longitud, actualizar Turno')
                //this.updateTurnos(this.acceso.claveTurno, claveTurnoNew)
              }

        }  else {
          console.log('No válido para cargar')
        }

      },

      checkFaltantes(cTNew) {
        console.log(cTNew)
        // Si hay menos registros actualizados de los seleccionados, se agrega el pendiente.
        if (this.count_Actualizados < this.itemsAutoSelect.length) {
          console.log('Agregar item full faltante')
          let idAcc = Date.now()  
          autotanquesServicesIRGE.addAcceso(idAcc, this.acceso.fechaLlegada, this.acceso.fechaReporte, this.itemSelAutoFull.pg, cTNew, this.itemSelOper.id, this.itemSelOper.nombre, this.itemSelOper.foto, this.itemSelOper.telefono, this.userLogin.id, this.userLogin.nombre, this.gruposSelect)
            .then(res => {
              console.log('Agregar registro de acceso')
              if (res.success) {
                // Agregar addAccesoPG
                let id_addAcceso_Pg = Date.now()
                autotanquesServicesIRGE.addPG_acceso(id_addAcceso_Pg, idAcc, this.itemSelAutoFull.pg)
                  .then(res_AddPG => {
                    console.log('Agregar puntos a pg')
                    console.log(res_AddPG)
                    if (res_AddPG.success) {
                      let capacidad = parseInt(this.itemSelAutoFull.capacidad) / 1000
                      let cap = parseInt(this.itemSelAutoFull.capacidad)
                      let cap82 = (cap * 82) / 90
                      let barriles = cap82 / 158.9873
                      let tons = barriles / 11.83
                      let idTurno = Date.now()
                      turnosServicesIRGE.addAutotanque(idTurno,this.itemSelAutoFull.pg, this.gruposSelect, capacidad, cTNew, 0, this.acceso.fechaLlegada, this.acceso.fechaReporte, 0, tons)
                        .then( resAdd => {
                          console.log('Agregando a listado de turnos')
                          console.log(resAdd)
                          if (resAdd.success) {
                            let toast = this.$toasted.show(`La llegada del autotanque ${this.itemSelAutoFull.pg}, ha sido registrada.`, { 
                              theme: "toasted-primary", 
                              position: "bottom-right", 
                              duration : 3000,
                              iconPack: 'fontawesome',
                              icon: 'check',
                              action : {
                                text : 'Ok',
                                onClick : (e, toastObject) => {
                                  this.$router.push('/IRGE/Accesos')
                                  toastObject.goAway(0)
                                }
                              },
                            })
                            this.isLoading = false
                          } else {
                            this.isLoading = false
                            console.log(resAdd.respuesta)
                          }
                        })
                        .catch(e => console.log(e))
                    }  else {
                      console.log(res_AddPG.respuesta)
                    }
                  })
              } else {
                let toast = this.$toasted.show(`Error no se ha podido registrar el ${this.itemSelAutoFull.pg}.`, { 
                  theme: "toasted-primary", 
                  position: "bottom-right", 
                  duration : 3000,
                  iconPack: 'fontawesome',
                  icon: 'exclamation-triangle',
                  action : {
                    text : 'Ok',
                    onClick : (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                })
              }
              setTimeout(() => {
                this.$router.push('/IRGE/Accesos')
              }, 350)
            })
        } else {
          console.log('Ya están completos')
          this.isformAccesoDisabled = true
          this.isformAccesoEditing = true
          this.isformAccesoUpdating = false
          this.isLoading = false
          this.$router.push('/IRGE/Accesos')
          //this.updateTurnos(this.acceso.claveTurno, cTNew)
        }
      },

      updateTurnos(cTOld, cTNew) {
        console.log(cTOld)
        console.log(cTNew)
        let index = 0
        turnosServicesIRGE.getPg_CT(cTOld)
          .then( res => {
            console.log(res)
            if (res.length > 0) {
              let countUpd = 0
              res.forEach(turnos => {
                let pgIndex = this.itemsAutoSelect[index].pg
                let capacidad = parseInt(this.itemsAutoSelect[index].capacidad) / 1000
                let cap = parseInt(this.itemsAutoSelect[index].capacidad)
                let cap82 = (cap * 82) / 90
                let barriles = cap82 / 158.9873
                let tons = barriles / 11.83
                turnosServicesIRGE.updateDataTurno(turnos.id, cTNew, pgIndex, this.gruposSelect, capacidad, tons)
                  .then( resUT => {
                    console.log(resUT)
                    if (resUT.success) {
                      console.log(countUpd)
                    } else {
                      let toast = this.$toasted.show(`error: ${resUT.respuesta}.`, { 
                        theme: "toasted-primary", 
                        position: "bottom-right", 
                        duration : 3000,
                        iconPack: 'fontawesome',
                        icon: 'exclamation-triangle',
                        action : {
                          text : 'Ok',
                          onClick : (e, toastObject) => {
                            toastObject.goAway(0)
                          }
                        },
                      })
                    }
                    this.count_turnosActualizados++
                    if (this.count_turnosActualizados == res.length) {
                      let toast = this.$toasted.show(`Los Datos del Acceso han sido actualizados.`, { 
                        theme: "toasted-primary", 
                        position: "bottom-right", 
                        duration : 3000,
                        iconPack: 'fontawesome',
                        icon: 'check',
                        action : {
                          text : 'Ok',
                          onClick : (e, toastObject) => {
                            this.$router.push('/IRGE/Accesos')
                            toastObject.goAway(0)
                          }
                        },
                      })
                      this.count_turnosActualizados = 0
                      this.isLoading = false
                      // setTimeout(() => {
                      //   this.isLoading = false
                      //   this.$router.push('/TPA/SCA/Accesos')
                      // }, 250)
                    }
                  })
                  .catch( error => console.log(error))
                index++
              })

              
            } else {
              this.isLoading = false
              console.log('No hay turnos en BD')
            }
          })
          .catch( e => console.log(e))

      },

      cancelEditLlegada () {
        this.isformAccesoDisabled = true
        this.isformAccesoEditing = true
        this.isformAccesoUpdating = false
      },

      cerrarModal () {
        this.titleModal = ''
        this.contentModal = ''
        this.modalStatus = false
      },

      comprobarNominacion() {
        this.puedeCargar = true

        // turnosServicesIRGE.getNominacionUN(this.gruposSelect, this.fechaJornada)
        //   .then( res => {
        //     this.unidadNegocio = res[0]
        //     console.log(this.unidadNegocio)
        //     turnosServicesIRGE.getSurtidoUN(this.gruposSelect, this.fechaJornada)
        //       .then( resp => {
        //         console.log(resp)
        //         console.log(parseInt(this.unidadNegocio.nominacion))
        //         console.log(parseInt(resp[0].cap_atendida))
        //         if (parseInt(resp[0].cap_atendida) >= 0 && parseInt(resp[0].cap_atendida) <= parseInt(this.unidadNegocio.nominacion)) {
        //           this.resultNom = `<div class="notification is-info">
        //           Válido para acceder.
        //         </div>`
        //         this.puedeCargar = true
        //         } else {
        //           this.resultNom = `<div class="notification is-danger">
        //           Puede acceder, pero estará en lista de espera, hasta esperar nuevas indicaciones.
        //         </div>`
        //         this.puedeCargar = true
        //         }
        //       })
        //       .catch(er => console.log(er))
        //   })
        //   .catch( e => console.log(e))
      },

      guardarOperador() {
        this.isLoading = true
        console.log('Guardar Operador')
        let id = Date.now()
        autotanquesServicesIRGE.guadarOperador(id, this.operadorNuevo)
          .then(resp => {
            console.log(resp)
            if (resp.success) {
              let toast = this.$toasted.show(`El operador ha sido Registrado.`, { 
                theme: "toasted-primary", 
                position: "bottom-right", 
                duration : 3000,
                iconPack: 'fontawesome',
                icon: 'check',
                action : {
                  text : 'Ok',
                  onClick : (e, toastObject) => {
                    toastObject.goAway(0)
                  }
                },
              })
              this.verAgregarOper = false
              this.isLoading = false
              this.obtenerOperadores()
            } else {
              let toast = this.$toasted.show(`Error: El operador No se pudo Registrar.`, { 
                theme: "toasted-primary", 
                position: "bottom-right", 
                duration : 3000,
                iconPack: 'fontawesome',
                icon: 'check',
                action : {
                  text : 'Ok',
                  onClick : (e, toastObject) => {
                    toastObject.goAway(0)
                  }
                },
              })
              this.isLoading = false
            }
          })
          .catch(e => console.log(e))
      },
      
      cancelarGuardarOperador () {
        this.verAgregarOper = false
      },

      checkFormOperadores (val) {
        this.isTH_disabled = false
        console.log(`isTH_disabled: ${this.isTH_disabled}`)
        console.log(val)
        switch (val) {
          case 'save':
            this.updateOperador = true
            this.isTH_disabled = false
            this.obtenerOperadores()  
            break
          case 'cancel':
            this.updateOperador = false
            this.isTH_disabled = false
            this.itemSelOper = {}  
            break
          case 'edit':
            this.updateOperador = true
            this.isTH_disabled = true
            break
        
          default:
            break
        }
      },
      cambiarOperadorForm () {
        console.log('cambiar Operador del form')
        let prov = {}
        prov = Object.assign(prov, this.itemSelOper)
        console.log(prov)
        this.itemSelOper = {}
        this.itemSelOper = this.operadores.find( oper => oper.id === prov.id )
        this.isTH_disabled = false
        console.log(`isTH_disabled: ${this.isTH_disabled}`)
      }
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['userLogin'])
    }
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/acceso/EditarAcceso.vue